import React from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from '../../../../redux/slices/Modal/modalSlice'
import { CancelButton } from '../../../styled/global.style'
import { useLocation } from 'react-router-dom'

const ModalCancelButton = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const closeModalApp = () => {
    if (['/trade', '/deal'].includes(pathname)) {
      window.close()
    } else {
      dispatch(closeModal())
    }
  }

  return <CancelButton onClick={closeModalApp}>Cancel</CancelButton>
}

export default ModalCancelButton
